import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { MsalService } from '@azure/msal-angular';

export function initializeMsal() {
  const platformId = inject(PLATFORM_ID);
  if (!isPlatformBrowser(platformId)) {
    return Promise.resolve();
  }

  const msalService = inject(MsalService);
  return msalService.instance
    .initialize()
    .then(() => msalService.instance.handleRedirectPromise());
}
